import { EvalYearTransfer }      from 'Component/EvalYearTransfer/EvalYearTransfer';
import { CustomSearchBarDrawer } from 'Container/CustomSearchBarDrawer/CustomSearchBarDrawer';
import React                     from 'react';

export const EvalYear = (props) => (
  <CustomSearchBarDrawer {...props}>
    {({ value, onChange }) => <EvalYearTransfer value={value} onChange={onChange} />}
  </CustomSearchBarDrawer>
);
